module.exports = __webpack_public_path__ + "school/img/123.e9177f6c.jpg";